import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { SuperAdminService } from '@core/services/super-admin.service';
import { SuccessFailedModalComponent } from '../success-failed-modal/success-failed-modal.component';
import { USER_ROLES } from '@shared/constant/shared.constant';
import { CustomValidator, validateInput } from '@shared/services/custom-validatior.abstract';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-custom-credits',
  templateUrl: './custom-credits.component.html',
  styleUrls: ['./custom-credits.component.scss']
})
export class CustomCreditsComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  creditForm: FormGroup; // Use `!` to indicate it will be initialized before use
  userData: any;
  dummy: string = '../../../../assets/images/dummy-img.png';
  companyList : any[] = []; 
  role  : string 
  userRoles = USER_ROLES;

  constructor(
    public readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig,
    private readonly fb: FormBuilder,
    private readonly superAdminService: SuperAdminService,
    private readonly dialogControlService: DialogControlService,
    private readonly encryptStorage: EncryptionStorageService
  ) { }

  ngOnInit(): void {
    this.userData = this.config.data.userData || {}; // Ensure `userData` is defined
    this.initializeForm();
    this.getCompanyList();
    this.role = this.encryptStorage.getItem('roleName')
  }

  initializeForm(): void {
    this.creditForm = this.fb.group({
      userId: [this.userData?.id],
      credit: ['', [Validators.required, Validators.max(9999), CustomValidator.validateGreaterThanZero]],
      reason: ['', [Validators.required, Validators.minLength(3)]],
      companyId: [null, Validators.required],
    });
  }

  get isSuperAdmin(): boolean {
    return this.role === this.userRoles.SUPER_ADMIN;
  }

   onKeyPressAllowTwoDigitAfterPoint(event: KeyboardEvent): void {
      if (!validateInput(event)) {
        event.preventDefault();
      }
    }

  addCustomCredit(): void {
    this.superAdminService.addCustomCredit(this.creditForm.value)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (res: any) => {
          this.closeDialog();
          this.openCustomCredits(res);
          
      }
    })
  }

  openCustomCredits(res: any) {
    this.dialogControlService.openDialog(SuccessFailedModalComponent, {
      styleClass: 'credits-success-model',
      data: {
        headerText: `Credits- ${res.data.credit} Points`,
        bodyText: res.message,
        buttonText: 'OK',
        svgType: 0
      },
    });
  }

onSubmit(): void {
    const companyIdControl = this.creditForm.get('companyId');
    if (this.isSuperAdmin) {
      companyIdControl?.setValidators(Validators.required);
    } else {
      companyIdControl?.clearValidators();
    }
    companyIdControl?.updateValueAndValidity();
    if (this.creditForm.valid) {
      this.addCustomCredit();
    } else {
      this.creditForm.markAllAsTouched();
    }
  }

  closeDialog() {
    this.ref.close();
  }

  getFlagClass(iso: string): string {
    return iso ? `fi fi-${iso.toLowerCase()}` : '';
  }

   getCompanyList() {
    
    const searchPayload = {
      search: '',
      sort: 1
    };
     this.superAdminService.getCompanyList(searchPayload)
     .pipe(autoUnsubWith(this.destroyRef))
     .subscribe({
       next: (response: any) => {
         this.companyList = response;
       }
     });
  }
}